// METIS screen help (the "?" at the top of METIS). Plain words; keep it in step with
// the screen in tools/MetisTool.tsx.
import type { ScreenHelpContent } from '../../v10/ScreenHelp';

export const metisHelp: ScreenHelpContent = {
  title: 'METIS',
  intro:
    "METIS is your plan for today. You list what you'll do and when, then tick things off as you go. Below that are this week's aims and this month's goals, so you can see how today's tasks fit the bigger picture.",
  sections: [
    {
      heading: 'AGENDA — TODAY',
      body: [
        "One row per task. Tap + Add Row for a new one. Type a time (like 9 or 2:30pm) and it tidies itself into 9:00 AM. Then type what the task is.",
        'Rows are kept in time order with your KYRS tasks and KRNOS events for today shown between them. Those are read-only here. Tap a KYRS · + AGENDA row to copy it into your agenda.',
        'Empty rows are not saved. Everything saves by itself a moment after you stop typing.',
      ],
    },
    {
      heading: 'Each row',
      items: [
        { term: 'Crosshair', text: 'Hold and drag to change the order. Drag it onto a weekly aim to link them. Tap it to pick which weekly aim the task belongs to. A ⛓ shows when a task is linked.' },
        { term: 'Round box', text: 'Tap to mark the task done (a tick). Press and hold for more choices: done, missed (pick a reason), auto-reschedule to tomorrow at the same time, or pick a new date and time yourself. A missed task shows a !.' },
        { term: 'time', text: 'When the task starts.' },
        { term: '⋮', text: 'Opens the row\'s tabs. Tap a tab to open it, tap it again to close it.' },
      ],
    },
    {
      heading: 'The row tabs',
      items: [
        { term: 'THEMIS', text: 'Tap + New ORDER to fill in a short plan for this task: Orient, Regulate, Directions, Execute, Revise. Or pick one of your THEMIS protocols and press Apply & run to run it right here.' },
        { term: 'Nail', text: 'Nail timers for the task. + Add nail timer, name what you are nailing down, and press play. It counts down from the nail time you set in Settings and turns red near the end.' },
        { term: 'Notes', text: 'A free note for the task.' },
        { term: 'Dur', text: 'Type minutes and press play for a countdown timer. It beeps in the last 10 seconds and rings at the end. If Sets is on, it runs Work and Break rounds instead.' },
        { term: 'Info', text: "Shows the task's list, status, and whether it has a note or an ORDER. View full trajectory / history shows how the task links up to your aim, goal and Endeavour." },
        { term: 'Delete', text: 'Removes the row, after you confirm.' },
      ],
    },
    {
      heading: 'WEEKLY — AIMS and MONTHLY — GOALS',
      body: [
        "Tap a heading to open or close it. The weekly list shows this week's number. The monthly list shows this month.",
        'Tick the box when one is done, type to rename it, and tap × to delete it (you confirm first). + Add Goal adds your own. Hold and drag the crosshair to reorder.',
        'METIS fills these in for you from what you set in ATLAS. If you delete one of those, it stays gone.',
        'On a weekly aim, tap the crosshair to link it to a monthly goal. A ⛓ shows when it is linked.',
      ],
    },
    {
      heading: 'FLOW',
      body: [
        'Switch FLOW on to see a picture instead of the lists: monthly goals on top, weekly aims in the middle, today\'s tasks at the bottom. Lines join the ones you linked. Switch it off to go back to the lists.',
      ],
    },
    {
      heading: 'PROFILES (if turned on)',
      body: [
        'If you turn on PROFILES in Settings, a panel appears at the top. Use the arrows to change the day. Each profile is a part of your day with its own list of rows, and the one that matches the time now says Now. Tap ⋯ to set each profile\'s start and end time.',
        'The Sets switch turns on Work and Break rounds for the Dur timer. Flow is the same FLOW switch described above.',
      ],
    },
  ],
};
